module.exports = __webpack_public_path__ + "static/media/jason.4fbc4674.jpeg";